import { Clear, ExpandMore } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { PropsWithChildren } from 'react';

export const TextFieldv2 = ({ error, children, ...props }: PropsWithChildren<TextFieldProps & { onClear?: () => void }>) => (
    <TextField
        {...props}
        variant="filled"
        size="small"
        SelectProps={{
            IconComponent: ExpandMore,
            ...(props.SelectProps || {}),
            endAdornment:
                props.value && props.onClear ? (
                    <InputAdornment position="end" sx={{ mr: 3 }}>
                        <IconButton
                            edge="end"
                            onClick={(e) => {
                                e.preventDefault();
                                props.onClear?.();
                            }}
                        >
                            <Clear />
                        </IconButton>
                    </InputAdornment>
                ) : undefined
        }}
        InputProps={{
            ...(props.InputProps || {}),
            endAdornment:
                (props.InputProps || {}).endAdornment ||
                (props.value && props.onClear ? (
                    <InputAdornment position="end" sx={{ mr: 1 }}>
                        <IconButton
                            edge="end"
                            onClick={(e) => {
                                e.preventDefault();
                                props.onClear?.();
                            }}
                        >
                            <Clear />
                        </IconButton>
                    </InputAdornment>
                ) : undefined),
            hiddenLabel: true,
            disableUnderline: true,
            sx: { borderRadius: '8px', background: '#f5f6f7', outline: error ? 'solid 1px #EF5350' : 'none' },
            placeholder: error ? 'Required Field' : props.placeholder ?? ''
        }}
        fullWidth
    >
        {children}
    </TextField>
);
